module.exports = __webpack_public_path__ + "static/cornbread-df16621788c87bac92582744c3835bc5.jpg";